const genderOptions = [
  { name: "Male", value: 1 },
  { name: "Female", value: 2 },
  { name: "Male & Female", value: 3 },
  { name: "Children", value: 4 },
];

const spaceTypeOptions = [
  { name: "Workspace", value: "workSpace", icon: "pi pi-home" },
  {
    name: "Meeting Room",
    value: "meetingRoom",
    icon: "pi pi-home",
  },
  { name: "Workshop", value: "workShop", icon: "pi pi-home" },
  { name: "Office", value: "office", icon: "pi pi-building-fill" }, // building for office
  { name: "Hot Desk", value: "hotDesk", icon: "pi pi-desktop" },
];

const spaceTypeOptionsForClosure = [
  { name: "Workspace", value: "workSpace", icon: "pi pi-home" },
  {
    name: "Meeting Room",
    value: "meetingRoom",
    icon: "pi pi-home",
  },
];

const weekDays = [
  { name: "Every Sunday", value: "Sunday" },
  { name: "Every Monday", value: "Monday" },
  { name: "Every Tuesday", value: "Tuesday" },
  { name: "Every Wednesday", value: "Wednesday" },
  { name: "Every Thursday", value: "Thursday" },
  { name: "Every Friday", value: "Friday" },
  { name: "Every Saturday", value: "Saturday" },
];

const orderSpaceType = [
  { name: "Workspace", value: 1 },
  {
    name: "Meeting Room",
    value: 2,
  },
  { name: "Workshop", value: 3 },
  { name: "Office", value: 4 },
  { name: "Hot Desk", value: 5 },
];

const planOptions = [
  { name: "Monthly", value: "monthly" },
  { name: "Yearly", value: "yearly" },
];

const notificationTypes = [{ name: "All", value: "all" }];

const userRoleType = [
  { name: "Student", value: 1 },
  { name: "Employee", value: 2 },
  { name: "Business Owner", value: 3 },
  { name: "Others", value: 4 },
];

const customerGenderOptions = [
  { name: "All", value: null },
  { name: "Male", value: 1 },
  { name: "Female", value: 2 },
  { name: "Other", value: 3 },
];

const ratingOptions = [
  { name: "1", value: 1 },
  { name: "2", value: 2 },
  { name: "3", value: 3 },
  { name: "4", value: 4 },
  { name: "5", value: 5 },
];

const monthOptions = [
  { name: "1 Month", value: 1 },
  { name: "2 Months", value: 2 },
  { name: "3 Months", value: 3 },
  { name: "4 Months", value: 4 },
  { name: "5 Months", value: 5 },
  { name: "6 Months", value: 6 },
  { name: "7 Months", value: 7 },
  { name: "8 Months", value: 8 },
  { name: "9 Months", value: 9 },
  { name: "10 Months", value: 10 },
  { name: "11 Months", value: 11 },
  { name: "12 Months", value: 12 },
];

const couponRoleTypes = [
  { name: "All", value: 0 },
  { name: "Student", value: 1 },
  { name: "Employee", value: 2 },
  { name: "Business Owner", value: 3 },
  { name: "Other", value: 4 },
];

const percentageOptions = [
  { name: "5%", value: "5" },
  { name: "10%", value: "10" },
  { name: "15%", value: "15" },
  { name: "20%", value: "20" },
  { name: "25%", value: "25" },
  { name: "30%", value: "30" },
  { name: "35%", value: "35" },
  { name: "40%", value: "40" },
  { name: "45%", value: "45" },
  { name: "50%", value: "50" },
  { name: "55%", value: "55" },
  { name: "60%", value: "60" },
  { name: "65%", value: "65" },
  { name: "70%", value: "70" },
  { name: "75%", value: "75" },
  { name: "80%", value: "80" },
  { name: "85%", value: "85" },
  { name: "90%", value: "90" },
  { name: "95%", value: "95" },
  { name: "100%", value: "100" },
];

const locationTypeOptions = [
  {
    name: "Meeting Room",
    value: 1,
    icon: "pi pi-home",
  },
  { name: "Workspace", value: 2, icon: "pi pi-home" },

  { name: "Entire Branch", value: 3, icon: "pi pi-home" },
];

export {
  genderOptions,
  spaceTypeOptions,
  spaceTypeOptionsForClosure,
  weekDays,
  notificationTypes,
  orderSpaceType,
  userRoleType,
  customerGenderOptions,
  ratingOptions,
  monthOptions,
  couponRoleTypes,
  percentageOptions,
  locationTypeOptions,
  planOptions,
};
